(function () {
  var container = document.querySelector('[data-snippet="kos-uebersichtsseite"]');
  if (!container) return;

  var webinarsJson = container.getAttribute('data-webinars');
  var kosOnDemandJson = container.getAttribute('data-kos-on-demand');
  var validWebinars = hasValidDate(webinarsJson);

  if (validWebinars) {
    addKosToFrontEnd(JSON.parse(webinarsJson), '.kos__Element__Container');
    var evt = new CustomEvent('insert_kos', {
      detail: { kosOnDemand: kosOnDemandJson, kosCount: 2, kosTopic: '' }
    });
    window.dispatchEvent(evt);
  } else {
    var headline = document.querySelector('.kos__Headline');
    var subHeadline = document.querySelector('.kos__Subheadline');

    if (headline) headline.innerText = 'Leider aktuell keine kostenlosen Online-Seminare.';
    if (subHeadline) subHeadline.innerText = 'Schau gerne später wieder vorbei.';
  }

  function showMoreInfo(element) {
    var idx = '';

    if (element.id.includes('icon_')) {
      idx = element.id.replace('icon_', '');
    }
    if (element.id.includes('kos__MoreInfo__')) {
      idx = element.id.replace('kos__MoreInfo__', '');
    }
    if (element.id.includes('kos__Image__')) {
      idx = element.id.replace('kos__Image__', '');
    }

    var desWrapper = document.getElementById('kos__Description__Wrapper__' + idx);
    if (!desWrapper) return;

    var visibility = desWrapper.style.display;
    desWrapper.style.display = visibility === '' ? 'none' : '';
  }

  window.showMoreInfo = showMoreInfo;

  function showForm(element, index) {
    var width = element.clientWidth;
    var formState = element.getAttribute('data-formstate');
    var formFieldsString = element.getAttribute('data-formfields');
    var modifier = element.getAttribute('data-formmodifier');
    var btn = null;

    if (element.id === 'kosOnDemand__Element__0') {
      btn = document.getElementById('kosOnDemand__Btn__0').parentNode;
    } else {
      btn = document.getElementById('kos__Btn__' + index).parentNode;
    }

    element.removeChild(btn);

    if (typeof formFieldsString !== 'string') {
      console.error('data-formfields ist keine Zeichenkette.');
      return;
    }

    try {
      var formFields = JSON.parse(formFieldsString);
      if (!Array.isArray(formFields)) {
        console.error('data-formfields konnte nicht in ein Array umgewandelt werden.');
        return;
      }

      if (formState === 'false') {
        element.setAttribute('data-formstate', 'true');

        if (element.id === 'kosOnDemand__Element__0') {
          createForm('kosOnDemand__FormWrapper__0', formFields, modifier + index);
        } else {
          createForm('kos__FormWrapper__' + index, formFields, modifier + index);
        }

        var formParentEl = document.getElementById('constformbox__' + modifier + index);
        formParentEl.removeChild(formParentEl.querySelector('.contactform__title'));

        var otherEl = document.getElementById('constformbox__' + modifier + index);
        otherEl.style.display = 'none';

        formParentEl.parentNode.style.gap = '1rem';

        var consentEl = document.getElementById('contactform__consent_' + modifier + index);
        var pEl = consentEl.querySelector('.contactform__agb').querySelector('p');
        pEl.style.padding = '0px';
        pEl.style.margin = '0px';

        var form = document.getElementById('contactform_' + modifier + index);
        form.style.width = (width - 20) + 'px';
      }
    } catch (error) {
      console.error('Fehler beim Parsen von data-formfields:', error);
    }
  }

  window.showForm = showForm;

  function formatKosDate(inputDate) {
    var date = new Date(inputDate);
    var day = (date.getDate() < 10 ? '0' : '') + date.getDate();
    var month = (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
    var year = date.getFullYear();
    return day + '.' + month + '.' + year;
  }

  function isKosFutureDate(dateString) {
    return new Date(dateString) > new Date();
  }

  function createAnnouncementMessage(date) {
    var currentDate = new Date();
    var timeDifference = new Date(date) - currentDate;
    var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    var message = '';

    if (days < 7) {
      if (days >= 3 && days <= 6) {
        message = '<p>Jetzt noch schnell anmelden: <br>In <b>' + days + '</b> Tagen geht\'s los.</p>';
      } else if (days === 2) {
        message = '<p>Jetzt noch schnell anmelden: <br><b>Übermorgen</b> geht\'s los.</p>';
      } else if (days === 1) {
        message = hours >= 24
          ? '<p>Jetzt noch schnell anmelden: <br><b>Übermorgen</b> geht\'s los.</p>'
          : '<p>Jetzt noch schnell anmelden: <br><b>Morgen</b> geht\'s los.</p>';
      } else if (days === 0) {
        if (hours >= 2) {
          message = '<p>Jetzt noch schnell anmelden: <br>In <b>' + hours + '</b> Stunden geht\'s los.</p>';
        } else if (hours === 1) {
          message = '<p>Jetzt noch schnell anmelden: <br>In <b>' + hours + '</b> Stunde geht\'s los.</p>';
        } else if (minutes > 1) {
          message = '<p>Jetzt noch schnell anmelden: <br>In <b>' + minutes + '</b> Minuten geht\'s los.</p>';
        } else {
          message = '<p>Jetzt noch schnell anmelden: <br>Es geht <b>jetzt</b> los.</p>';
        }
      }
    } else {
      message = '<b>In ' + days + ' Tagen geht\'s los.</b>';
    }

    return message;
  }

  function addKosToFrontEnd(array, parentClass) {
    var newArray = Array.isArray(array) ? array : [array];
    var elementWrapper = document.querySelector(parentClass);

    newArray.forEach(function (webinar, index) {
      var listName = 'OMR_Education';
      var doiMessage = 'Die Anmeldung zum kostenlosen Online-Seminar war erfolgreich! Der Kalendereintrag mit deinem persönlichen Zugangslink ist auch schon auf dem Weg zu dir. Damit wir dir nach dem Online-Seminar die Aufzeichnung und die Slides zusenden können, bestätige bitte über den Button die Anmeldung zum OMR Education Newsletter.';

      if (webinar.webinarid.includes('hr_')) {
        listName = 'OMR HR';
        doiMessage = 'die Anmeldung zum kostenlosen Online-Seminar war erfolgreich! Der Kalendereintrag mit deinem persönlichen Zugangslink ist auch schon auf dem Weg zu dir. Damit wir dir nach dem Online-Seminar die Aufzeichnung und die Slides zusenden können, bestätige bitte über den Button die Anmeldung zum OMR HR Newsletter.';
      }

      if (!isKosFutureDate(webinar.timefull)) return;

      var formModifier = 'kosOverlayForm';
      var formFields = [{
        fields: [
          { row: [{ type: 'text', urlparamname: 'firstname', label: 'Vorname', placeholder: 'Dein Vorname', error: 'Bitte trage deinen Vornamen ein', required: 'true' }] },
          { row: [{ type: 'email', urlparamname: 'email', label: 'E-Mail', placeholder: 'Deine E-Mail', error: 'Bitte trage deine E-Mail ein', required: 'true' }] },
          { row: [{ type: 'math', label: 'Validierung', urlparamname: 'math', placeholder: 'Bitte löse diese Matheaufgabe', error: 'Bitte zeige uns, dass du kein Bot bist und löse diese Matheaufgabe', required: 'true' }] }
        ],
        headlines: { headline: ' ' },
        agb: { text: 'Mit dem Absenden stimmst du unserer Datenschutzerklärung zu.' },
        button: { text: 'Absenden' },
        success: { icon: '✔️', message: 'Danke das hat geklappt. Der Kalendereintrag mit deinem persönlichen Zugangslink ist bereits auf dem Weg zu dir.', filedownoad: '', buttontext: '', url: '' },
        tracking: {
          webhook: 'https://hooks.zapier.com/hooks/catch/590116/3wrzncq/',
          additionalparams: [
            { key: 'list', value: listName },
            { key: 'utm_content', value: 'kos-overlay-form' },
            { key: 'doimessage', value: doiMessage },
            { key: 'webinarid', value: webinar.webinarid },
            { key: 'kosname', value: webinar.webinarTag }
          ]
        },
        background: { desktopleft: '', desktopright: '', laptopleft: '', laptopright: '', tabletleft: '', tabletright: '', mobileleft: '', mobileright: '' },
        color: ''
      }];

      var startTime = formatKosDate(webinar.timefull);
      var landingPageUrl = webinar.landingpageurl;
      var userMessage = createAnnouncementMessage(webinar.timefull);
      var bgCol = userMessage ? 'var(--custom-color-yellow)' : '';

      var kosWrapperEl = document.createElement('div');
      kosWrapperEl.classList.add('kos__Element__Wrapper');
      kosWrapperEl.setAttribute('id', 'kos__Element__Wrapper__' + index);

      var kosEl = document.createElement('div');
      kosEl.classList.add('kos__Element');
      kosEl.setAttribute('id', 'kos__Element__' + index);
      kosEl.setAttribute('data-formmodifier', formModifier);
      kosEl.setAttribute('data-formfields', JSON.stringify(formFields));
      kosEl.setAttribute('data-formid', 'kos__Element');
      kosEl.setAttribute('data-formstate', 'false');

      kosEl.innerHTML =
        '<div class="kos__Anouncement" id="kos__Announcement__' + index + '" style="background-color: ' + bgCol + '">' + userMessage + '</div>' +
        '<picture>' +
          '<source media="(min-width: 1440px)" srcset="' + webinar.imageurl + '&width=1440">' +
          '<source media="(min-width: 1024px)" srcset="' + webinar.imageurl + '&width=1024">' +
          '<source media="(min-width: 768px)" srcset="' + webinar.imageurl + '&width=768">' +
          '<img id="kos__Image__' + index + '" alt="Webinar ' + (index + 1) + ' banner" src="' + webinar.imageurl + '&width=320" loading="lazy" width="320" height="320">' +
        '</picture>' +
        '<div class="kos__Description__Wrapper" id="kos__Description__Wrapper__' + index + '" style="display: none">' +
          '<div class="kos__DescriptionClose__Wrapper"><div class="descriptionClose" id="descriptionClose__' + index + '" onclick="showMoreInfo(this)">X</div></div>' +
          '<div class="kos__Description" id="kos__">' + webinar.description + '</div>' +
          '<div class="kos__TriangleDown" id="kos__TriangleDown__' + index + '"></div>' +
        '</div>' +
        '<div class="kos__Content__Wrapper" id="kos__Content__Wrapper__' + index + '">' +
          '<div class="kos__Title" id="kos__Title__' + index + '">' + webinar.fulltitle + '</div>' +
          '<div class="kos__MoreInfo" id="kos__MoreInfo__' + index + '" onclick="showMoreInfo(this)">Mehr Infos</div>' +
          '<div class="kos__Date" id="kos__Date__' + index + '">' + startTime + ' von ' + webinar.time + '</div>' +
        '</div>' +
        '<div class="kos__Btn__Wrapper">' +
          '<div class="kos__Btn" id="kos__Btn__' + index + '" onclick="showForm(this.parentNode.parentNode, ' + index + ')">Jetzt Kostenlos anmelden</div>' +
        '</div>' +
        '<div class="kos__Btn__Wrapper">' +
          '<a href="' + landingPageUrl + '"><div class="kos__Btn__ToPage">Mehr Infos</div></a>' +
        '</div>';

      var kosFormWrapper = document.createElement('div');
      kosFormWrapper.classList.add('kos__FormWrapper');
      kosFormWrapper.setAttribute('id', 'kos__FormWrapper__' + index);

      kosWrapperEl.appendChild(kosEl);
      kosWrapperEl.appendChild(kosFormWrapper);
      elementWrapper.appendChild(kosWrapperEl);
    });
  }

  function hasValidDate(arrayString) {
    var array = JSON.parse(arrayString);
    var newArray = Array.isArray(array) ? array : [array];
    var currentDate = new Date();

    for (var i = 0; i < newArray.length; i++) {
      if (new Date(newArray[i].timefull) > currentDate) {
        return true;
      }
    }
    return false;
  }
})();
